import { Subject } from 'rxjs'

const subject = new Subject()

export const downloadProgressService = {
  emitReload: (val) => subject.next(val),
  reload: () => subject.asObservable(),
}
